// @flow

import Request from '@insolus/request';
import formatProgressPercent from 'utils/formatProgressPercent';

import type { RequestPromise } from '@insolus/request';
import type {
    AllPaginateParams,
    PaginatedResult,
    SeoFieldTranslations,
    SeoFields,
    ProgressFunction
} from 'stores/api/_types';

type ManufacturerBase = {|
    name: string,
    isFeatured: boolean,
    ...SeoFields
|};

export type Manufacturer = {|
    ...ManufacturerBase,
    id: number,
    logo?: string,
    logoUrl?: string,
    ...SeoFieldTranslations
|};

export type ManufacturerFormData = {|
    ...Manufacturer,
    logo?: string
|};

// ------------------------------------------------------
// -
// -    Functions
// -
// ------------------------------------------------------

const all = (params?: AllPaginateParams): RequestPromise<PaginatedResult<Manufacturer[]>> => Request.get('/manufacturers', { params });

const get = (id: number): RequestPromise<Manufacturer> => Request.get(`/manufacturers/${id}`);

const add = (manufacturer: ManufacturerFormData): RequestPromise<Manufacturer> => Request.post('/manufacturers', manufacturer);

const edit = (id: number, manufacturer: ManufacturerFormData): RequestPromise<Manufacturer> => Request.put(`/manufacturers/${id}`, manufacturer);

const remove = (id: number): RequestPromise<void> => Request.delete(`/manufacturers/${id}`);

const editLogo = (
    id: number, formData: FormData, onProgress: ProgressFunction
): RequestPromise<Manufacturer> => (
    Request.post(`/manufacturers/${id}/logo`, formData, {
        onUploadProgress: (e: ProgressEvent) => {
            onProgress(formatProgressPercent(e));
        },
        timeout: 60000
    })
);

const removeLogo = (id: number): RequestPromise<Manufacturer> => (
    Request.delete(`/manufacturers/${id}/logo`)
);

export default { all, get, add, edit, remove, editLogo, removeLogo };
